import { defineMessages } from "react-intl";

const PREFIX = "Favourites.DeleteFavouriteDialog";
export default defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Remove from Favourites",
  },
  contentText: {
    id: `${PREFIX}.contentText`,
    defaultMessage: 'Are you sure you want to remove the "{favouriteItemName}" from Favourites?',
  },
  remove: {
    id: `${PREFIX}.remove`,
    defaultMessage: "Remove",
  },
  cancel: {
    id: `${PREFIX}.cancel`,
    defaultMessage: "Cancel",
  },
});
